import { TRIPS_LOADED } from '../constants/actionTypes';

export default (state = [], action) => {
  switch (action.type) {
    case TRIPS_LOADED:
      return action.payload && action.payload[0] ? action.payload[0] : state;
    default:
      return state;
  }
};
